import { useEffect, useState } from 'react'
import { Clock } from 'lucide-react'

interface SessionTimerProps {
  startedAt: string
}

export function SessionTimer({ startedAt }: SessionTimerProps) {
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const startTime = new Date(startedAt).getTime()

    const calculateElapsed = () => {
      const now = Date.now()
      const diffSeconds = Math.floor((now - startTime) / 1000)
      setElapsed(diffSeconds)
    }

    // Initial calculation
    calculateElapsed()

    // Update every second
    const interval = setInterval(calculateElapsed, 1000)

    return () => clearInterval(interval)
  }, [startedAt])

  const formatTime = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60

    if (hours > 0) {
      return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    }
    return `${minutes}:${String(secs).padStart(2, '0')}`
  }

  return (
    <div
      className="flex items-center gap-2 text-sm text-muted-foreground"
      aria-live="off"
      aria-label={`Session duration: ${formatTime(elapsed)}`}
    >
      <Clock className="h-4 w-4" aria-hidden="true" />
      <span>{formatTime(elapsed)}</span>
    </div>
  )
}
